import { Alert, Heading, Link, BodyLong, VerticalSpace } from '@elhub/ds-components'

import React from 'react'
import { Link as NavLink } from 'react-router-dom'

interface DatasetDisclaimersProps {
  entity: string
}

type EntityDisclaimers = {
  [key: string]: JSX.Element | null
}

const DatasetDisclaimers: React.FC<DatasetDisclaimersProps> = ({ entity }) => {
  return (
    <>
      <BodyLong size='small'>
        <Heading size='xsmall' level='5'>
          <b>Usage Guidelines:</b>
        </Heading>
        <VerticalSpace />
        See {' '}
        <Link as={NavLink} to='/energy-data-api#/dataset-guidelines'>
          here
        </Link>  {' '}
        for date filtering rules, authentication, and dataset-specific restrictions.
      </BodyLong>
      <VerticalSpace />
      <VerticalSpace />
      {/* <BodyLong size='small'>
        <Heading size='xsmall' level='5'>
          <b>Confidentiality Rules:</b>
        </Heading>
        <VerticalSpace />
        See {' '}
        <Link as={NavLink} to='/energy-data-api#/confidentiality-principles'>
          here
        </Link>  {' '}
        for data exposure restrictions.
      </BodyLong>
      <VerticalSpace /> */}
      {getEntityDisclaimer(entity)}
    </>
  )
}

const getEntityDisclaimer = (entity: string) => {
  const disclaimers: EntityDisclaimers = {
    'grid-areas': (
      <>
        <Alert variant='info'>
          <b>Some information about the dataset: 'CONSUMPTION_PER_GROUP_MGA_HOUR'</b>
          <ul>
            <li>Only grid areas aggregates with at least 5000 consumption points are included</li>
            <li>Aggregates with at least 100 consumption points in each consumption group are included</li>
            <li>Only distribution and regional grids are included (Z01 and Z04)</li>
          </ul>
        </Alert>
        <VerticalSpace />
        <Alert variant='info'>
          <b>Some information about the dataset: 'LOSS_PER_MGA_HOUR'</b>
          <ul>
            <li>Only distribution and regional grids are included (Z01 and Z04)</li>
          </ul>
        </Alert>
        <VerticalSpace />
      </>
    ),
    'metering-points': (
      <>
        <Alert variant='info'>
          <b>Some information about the dataset: 'METERING_VALUES_HOUR_RESTRICTED'</b>
          <VerticalSpace />
          <ol>
            <li>
              <b>Regarding scopes:</b>
              <ul>
                <li>
                  For scope <code>elhub:enduser</code>, <code>metering-point-id</code> is not required, and <code>endUserId</code> cannot be used as a filter parameter.
                </li>
                <li>
                  For scope <code>elhub:thirdparty</code>, <code>metering-point-id</code> is required, and <code>endUserId</code> can be used as a filter parameter.
                </li>
              </ul>
            </li>
            <VerticalSpace />
            <li>
              <b>Date usage:</b>
              <ul>
                <li>
                  If either <code>startDate</code> or <code>endDate</code> is missing, the default data range will be 1 day.
                </li>
                <li>
                  Data can be queried up to 3 years and 41 days back in time, which is the oldest available.
                </li>
                <li>
                  When <code>metering-point-id</code> is provided, the maximum allowed data range is 3 years and 41 days. Otherwise, it defaults to 1 day.
                </li>
                <li>
                  If both <code>insertDateTime</code> and <code>metering-point-id</code> are provided, the default <code>startDate</code>/<code>endDate</code> range is 3 years and 41 days unless explicitly specified.
                </li>
              </ul>
            </li>
          </ol>
        </Alert>
        <VerticalSpace />
      </>
    )
  }

  return disclaimers[entity] || null
}

export default DatasetDisclaimers
